import { Stack, Tooltip, Typography } from "@mui/material";
import { Progress } from "../Progress";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { AnalyticCardWrapper } from "../AnalyticCardWrapper";
import { RateIndicator } from "../../../../types/enums";
import { AnalyticsDataBlock } from "../AnalyticsDataBlock";

type Props = {
  expectedSize: number;
  currentSize: number;
  original: number;
  enriched: number;
  children?: React.ReactNode;
  currentTab?: string;
  enriched_indicator?: RateIndicator;
  enriched_change?: number;
  enriched_changed_at?: string;
  original_indicator?: RateIndicator;
  original_change?: number;
  original_changed_at?: string;
};

type TooltipsOption = "Buying Committee" | "Buying Cluster";

const getTooltipText = (key: TooltipsOption, members: number) => {
  const tooltips: Record<TooltipsOption, string> = {
    "Buying Committee": `Possible buying committee size based on company size: up to ${members} members`,
    "Buying Cluster": `Possible buying cluster size based on company size: up to ${members} members`,
  };

  return tooltips[key];
};

export const AccountDiscoveryRate = ({
  expectedSize,
  original,
  enriched,
  children,
  currentTab,
}: Props) => {
  return (
    <AnalyticCardWrapper
      title="Members Identified"
      tooltip="Rate of discovered BC members in account data, relative to the expected number
       of BC for this company size."
    >
      {children}
      <Stack
        gap="20px"
        flexGrow={1}
        minWidth="300px"
        justifyContent="space-between"
      >
        <Stack gap={"8px"}>
          <Stack direction="row" alignItems={"center"} gap={"8px"}>
            <Typography variant="h2" color="#051123" sx={{ fontSize: "32px" }}>
              {(original ?? 0) + (enriched ?? 0)}%
            </Typography>
            <Tooltip
              placement="bottom"
              sx={{
                background: "#596177E5",
                fontSize: "12px",
                lineHeight: "16px",
              }}
              arrow
              title={getTooltipText(currentTab as TooltipsOption, expectedSize)}
            >
              <HelpOutlineIcon sx={{ color: "#1C3C6C" }} />
            </Tooltip>
            <Typography variant="body1" color="#051123">
              of all members
            </Typography>
          </Stack>
          <Progress primaryValue={original} secondaryValue={enriched} />
        </Stack>
        <AnalyticsDataBlock your_data={original} external_data={enriched} />
      </Stack>
    </AnalyticCardWrapper>
  );
};
